import React from 'react'
import PropTypes from 'prop-types'
import H3 from '../../../../../shared/Headings/H3'
import Img from 'src/components/shared/Img'

const OurPrinciplesItem = ({ img: { src, alt }, title, description }) => {
  return (
    <div>
      <div className="gap-x-primary mx-2 flex min-h-96 flex-equal flex-col items-start border px-10 py-7 lg:mx-4 lg:min-h-84 lg:items-center lg:py-7">
        <div className="min-h-26">
          <Img
            src={src}
            alt={alt}
            width={282}
            height={72}
            layout="intrinsic"
            className="relative lg:mx-auto"
            imgClassName="object-contain"
          />
          <H3
            text={title}
            id={title}
            className="lg:text-1.9 mt-5 whitespace-pre-line text-left text-lg font-medium lg:mt-4 lg:text-center"
          />
        </div>
        <p
          className="mt-4 min-h-40 text-left text-15 leading-170 text-gray-960 lg:mt-4 lg:text-center"
          data-testid="custom-description"
        >
          {description}
        </p>
      </div>
    </div>
  )
}

OurPrinciplesItem.propTypes = {
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}
export default OurPrinciplesItem
